import { useEffect, useState } from "react";
import * as logClient from "@classdojo/log-client";

interface TelemetryOptions {
  eventName: string;
  metadata?: Record<string, unknown>;
}

export const useLogRenderedDuration = (options: TelemetryOptions) => {
  const [startTime] = useState(() => Date.now());

  useEffect(() => {
    return () => {
      const duration = Date.now() - startTime;

      try {
        void logClient.logEvent({
          eventName: options.eventName,
          eventValue: duration,
          metadata: options.metadata,
        });
        // eslint-disable-next-line no-catch-all/no-catch-all -- pre-existing violation
      } catch (error) {
        // eslint-disable-next-line no-console -- pre-existing violation
        console.warn(`Failed to log ${options.eventName} duration:`, error);
      }
    };
  }, [options.eventName, options.metadata, startTime]);
};
